// Copyright 2022 Amazon.com, Inc. or its affiliates. All Rights Reserved.
export enum AuthStatus {
    SIGNED_IN = "SIGNED_IN",
    SIGNED_OUT = "SIGNED_OUT",
    LOADING = "LOADING",
    // TODO [LOWA-30534] This is only for old flow
    SIGNING_OUT = "SIGNING_OUT",
    // TODO [LOWA-30534] This is only for new flow
    UNAUTHENTICATED = "UNAUTHENTICATED",
}
